import { createContext } from 'react';

type State = {
  birthdate: string;
  setBirthdate: (birthdate: string) => void;
};

const AgeGateContext = createContext<State>({} as State);

export default AgeGateContext;
